<template>

    <div class="form-group">
        <label for="phone">{{ label }}</label>

        <div class="input-group flex-wrap" :class="[error ? 'is-invalid' : '']">

            <input type="tel" id="phone" class="form-control"
                   :class="[error ? 'is-invalid' : '']"
                   :placeholder="placeholder"
                   v-model="inputVal"
                   @input="update"
                   @blur="blur"
                   @focus="focus">

            <input type="hidden" :name="name" :value="hiddenVal">

            <div class="input-group-append">
                <span class="input-group-text">
                    <svg><use xlink:href="/img/icons/phone.svg#Symbols" href="/img/icons/phone.svg#Symbols"></use></svg>
                </span>
            </div>

            <div class="invalid-feedback" v-if="error">
                <strong>{{ error }}</strong>
            </div>

        </div>
    </div>

    <!--<div class="form-group row">-->
        <!--<label for="phone" class="col-md-4 col-form-label text-md-right">Phone</label>-->

        <!--<div class="col-md-6">-->

            <!--<div class="input-group">-->

                <!--<div class="input-group-prepend">-->
                    <!--<label class="input-group-text" for="phone">{{ country }}</label>-->
                <!--</div>-->

                <!--<input id="phone" type="text" class="form-control" :class="[error ? 'is-invalid' : '']" v-model="inputVal" @input="update" @blur="blur" @focus="focus">-->
                <!--<input type="hidden" name="phone" :value="hiddenVal">-->

                <!--<span class="invalid-feedback" v-if="error">-->
                    <!--<strong>{{ error }}</strong>-->
                <!--</span>-->
                <!---->
            <!--</div>-->

        <!--</div>-->
    <!--</div>-->

</template>

<script>

    import {AsYouType, formatNumber, parseNumber, isValidNumber} from 'libphonenumber-js'
    // import metadata from 'libphonenumber-js/metadata.full.json'

    export default {

        props: {

            label: {
                default: 'Phone'
            },

            placeholder: {
                default: ''
            },

            value: {
                default: ''
            },

            defaultCountry: {
                default: 'BE'
            },

            name: {
                default: 'phone'
            },

            invalid: {
                default: false
            },

			empty: {
                default: false
            },
        },

        data() {
            return {
                hiddenVal: '',
                inputVal: '',

                country: '',
                valid: false,
                error: false,
                asyoutype: null,
            }
        },

        mounted() {
            this.asyoutype = new AsYouType(this.defaultCountry)
            this.inputVal = this.hiddenVal = this.value
            this.country = this.defaultCountry
            //this.error = this.invalid

            this.update()
        },

        methods: {

            update() {
                this.asyoutype.reset()
                this.inputVal = this.asyoutype.input(this.inputVal)

                this.country = this.asyoutype.country
                this.valid = this.country !== undefined && isValidNumber(this.inputVal, this.asyoutype.country)

                this.hiddenVal = this.valid ? formatNumber(parseNumber(this.inputVal, this.asyoutype.country), 'E.164') : ''

                this.$emit('input', this.hiddenVal)
            },

            focus() {
                this.error = false
            },

            blur() {

				console.log(this.inputVal);

				if(!this.inputVal) {
					this.error = this.empty
				} else if(!this.valid)
                    this.error = this.invalid

                if(this.valid)
                    this.inputVal = formatNumber(parseNumber(this.inputVal, this.asyoutype.country), 'International')
            }

        }

    }

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/RPhone.vue